module.exports = __webpack_public_path__ + "img/editEmailTemplateDialog.64bdfad7.jpg";